import { Router, ActivatedRoute } from '@angular/router';
import { Component, HostListener, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { NAVBAR_ROUTES } from './navbar-routes.config';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  routes = NAVBAR_ROUTES;
  menuToggle = false;
  subscriptions: Subscription[] = [];
  userData;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<{ config: any }>
  ) {}

  @HostListener('window:resize', ['$event'])
  ngOnInit(): void {
    this.onResize();

    this.subscriptions.push(
      this.store.select('config').subscribe((res) => {
        this.userData = res.userData?.data;
      })
    );
  }

  onResize(event = '') {
    if (window.innerWidth > 530) {
      this.menuToggle = true;
    }
  }

  onNavigate(route) {
    this.router.navigate([route], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
    });
    if (window.innerWidth < 530) {
      this.menuToggle = false;
    }
  }
}
